export default "__VITE_ASSET__DSM9RsFI__"